import { useQuery, useQueryClient, useMutation } from 'react-query'
import { getProfile, updateProfileName } from '../api/userApi'
import type { UserProfile } from '../types'

export const PROFILE_QUERY_KEY = ['user', 'profile'] as const

/**
 * React Query-запрос текущего профиля пользователя.
 * @param enabled - Включён ли запрос (обычно — после установленной авторизации)
 * @returns UseQueryResult<UserProfile>
 */
export const useProfileQuery = (enabled = true) => {
  return useQuery<UserProfile>(PROFILE_QUERY_KEY, getProfile, {
    enabled,
    staleTime: 60_000,
    retry: false
  })
}

/**
 * Возвращает функцию, инвалидирующую кеш профиля.
 * Используется после мутаций, меняющих профиль (link-email, link-telegram, update-name).
 * @returns Функция invalidate
 */
export const useInvalidateProfile = () => {
  const qc = useQueryClient()
  return () => qc.invalidateQueries(PROFILE_QUERY_KEY)
}

/**
 * Мутация обновления имени пользователя. После успеха кеш профиля обновляется.
 * @returns UseMutationResult для `PATCH /user/profile { name }`
 */
export const useUpdateProfileName = () => {
  const qc = useQueryClient()
  return useMutation(updateProfileName, {
    onSuccess: (profile) => {
      qc.setQueryData(PROFILE_QUERY_KEY, profile)
    }
  })
}
